import React, { useState } from "react";

//
import { Modal, Button } from "react-bootstrap";

//
import Calculate from "../../../assets/img/calculate.png";

function FearGreedQuestion() {
  const [show, setShow] = useState(false);
  return (
    <>
      <a className="outer-link pointer" onClick={() => setShow(true)}>
        Learn more
        <i className="las la-arrow-up"></i>
      </a>

      <Modal
        size="xl"
        id="learn-more-modal"
        centered
        show={show}
        onHide={() => setShow(false)}
      >
        <Modal.Header closeButton>
          <div style={{ backgroundImage: `url(${Calculate})` }}>
            <h3>How we Calculate the Index?</h3>
          </div>
        </Modal.Header>
        <Modal.Body>
          <article>
            <div className="paragraph mb-0">
              <p>
                The crypto market behavior is very emotional. People tend to get
                greedy when the market is rising which results in FOMO (Fear of
                missing out). Also, people often sell their coins in the
                irrational reaction of seeing red numbers. With our Fear and
                Greed Index, we try to save you from your own emotional
                overreactions. There are two simple assumptions:
              </p>
              <ul>
                <li>
                  <span className="fw-bolder text-black">Extreme fear</span> can
                  be a sign that investors are too worried. That could be a{" "}
                  <span className="fw-bolder text-black">
                    buying opportunity
                  </span>
                  .
                </li>
                <li>
                  When Investors are getting{" "}
                  <span className="fw-bolder text-black">too greedy</span>, that
                  means the market is
                  <span className="fw-bolder text-black">
                    {" "}
                    due for a correction
                  </span>
                  .
                </li>
              </ul>
            </div>

            <div className="paragraph">
              <p>
                Therefore, we analyze the current sentiment of the Bitcoin
                market and crunch the numbers into a simple meter from 0 to 100.
                Zero means "Extreme Fear", while 100 means "Extreme Greed". See
                below for further information on our data sources.
              </p>
            </div>
          </article>

          <Button
            className="close-modal"
            variant="white"
            size="lg"
            onClick={() => setShow(false)}
          >
            Close
          </Button>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default FearGreedQuestion;
